<script setup>
import panierMapper from "@/services/panier/panier-mapper";
import { useUpdateCartTracking } from "@/mixins/tracking/update-cart";
import { usePanachagesStore } from "@/store/panachages";
import { usePanierStore } from "@/store/panier";
import { useClientStore } from "@/store/client";

const { trackUpdateCart } = useUpdateCartTracking();
const { articleQuantite } = storeToRefs(usePanierStore());
const { isPro } = storeToRefs(useClientStore());
const { fetchPanachages: fetch } = usePanachagesStore();
const { syncArticles } = usePanierStore();

const props = defineProps({
  component: {
    type: [Function, Object],
    required: false,
    default: null
  },
  article: {
    type: Object,
    required: true
  },
  context: {
    type: String,
    required: false,
    default: null
  },
  cartContext: {
    type: String,
    required: false,
    default: null
  }
});

const _component = computed(() => {
  if (props.component) {
    return props.component;
  }
  return defineLazyAdaptiveComponent(
    "/components/organisms/product-list/product-list-item-advantages"
  );
});

const quantity = computed(() => {
  return articleQuantite.value(props.article.id);
});

const showPanachage = (article) => {
  fetch({
    link: article.lien_panachage_produits,
    title: article.texte_avantage,
    article: article
  });
};

const syncArticle = (article) => {
  syncArticles([article]);
};

const setQuantity = (newQuantity) => {
  const article = panierMapper.getArticleModel(props.article);
  trackUpdateCart({
    products: [{ ...article, quantity: newQuantity }],
    method: "add",
    context: `${trackingCodes.LABELGA.AnciennesCommandes}${trackingCodes.CONTEXTPANIER.AcheterLot}`
  });
  article.quantite = quantity.value + newQuantity;
  syncArticle(article);
};
</script>

<template>
  <component
    :is="_component"
    v-if="!isPro"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    :context="context"
    :available-quantity="article.qte_max_panier - quantity"
    @showPanachages="showPanachage"
    @setQuantity="setQuantity"
  />
</template>
